<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.bank-account.dialog.title' | translate"
		id="bank-account-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div class="grid" [sklValidationSource]="viewValidation">
					<div class="col-1">
						<ins-checkbox
							id="bank-account-dialog-default"
							[(ngModel)]="viewModel.bo.model.default"
							[label]="'scenes.configuration.shared.bank-account.dialog.form.default.label' | translate"
							[sklValidate]="getValidationKey('default')">
						</ins-checkbox>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.bank-account.dialog.form.currency.label' | translate">
							<ins-select
								id="bank-account-dialog-currency"
								[skl-focus-by]
								display-text="symbol"
								[readonly]="data.currencyId > 0"
								[placeholder]="'ui.placeholders.empty' | translate"
								[converter]="viewModel.currenciesConverter!"
								[(ngModel)]="viewModel.bo.model.currencyId"
								[sklValidate]="getValidationKey('currencyId')">
								@for (item of viewModel.currencies; track item) {
									<ins-option
										[value]="item">
										{{item.symbol}}
									</ins-option>
								}
							</ins-select>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.bank-account.dialog.form.account-number.label' | translate">
							<ins-input
								id="bank-account-dialog-number"
								[(ngModel)]="viewModel.bo.model.number"
								[placeholder]="'scenes.configuration.shared.bank-account.dialog.form.account-number.placeholder' | translate"
								[sklValidate]="getValidationKey('number')">
							</ins-input>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.bank-account.dialog.form.name.label' | translate">
							<ins-input
								id="bank-account-dialog-name"
								[(ngModel)]="viewModel.bo.model.name"
								[placeholder]="'scenes.configuration.shared.bank-account.dialog.form.name.placeholder' | translate"
								[sklValidate]="getValidationKey('name')">
							</ins-input>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.bank-account.dialog.form.bank-name.label' | translate">
							<ins-input
								id="bank-account-dialog-bank-name"
								[(ngModel)]="viewModel.bo.model.bankName"
								[placeholder]="'scenes.configuration.shared.bank-account.dialog.form.bank-name.placeholder' | translate"
								[sklValidate]="getValidationKey('bankName')">
							</ins-input>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.bank-account.dialog.form.swift.label' | translate">
							<ins-input
								id="bank-account-dialog-swift"
								[(ngModel)]="viewModel.bo.model.swift"
								[placeholder]="'scenes.configuration.shared.bank-account.dialog.form.swift.placeholder' | translate"
								[sklValidate]="getValidationKey('swift')">
							</ins-input>
						</ins-form-field>
					</div>
				</div>
			}
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="bank-account-dialog-cancel-button"
			(click)="onCancel()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			id="bank-account-dialog-save-button"
			typeName="accent"
			[spinner]="viewModel.isSaving"
			(click)="onConfirmAsync()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>